// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ onClick, ...other }) {
  // const { user } = useAuth();
  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <MAvatar
      onClick={onClick}
      src={user.profile_pic}
      alt={user.person_name}
      color={user.profile_pic ? 'default' : createAvatar(user.person_name).color}
      {...other}
    >
      {createAvatar(user.person_name).name}
    </MAvatar>
  );
}
